import React from "react";
import { useDispatch } from "react-redux";

import { PrintBookingTicket as PrintTicket } from "@app/dev/actions/terminal";
import { useTranslation } from "@common/hooks/translation";

import "./styles.scss";

export const PrintBookingTicket = ({ closePopup, bookingData }) => {
  const t = useTranslation();
  const dispatch = useDispatch();

  const handlePrintTicket = () => {
    dispatch(PrintTicket(bookingData));
    closePopup();
  };

  return (
    <div className="popup-content popup-small print-booking-ticket">
      <div className="popup-title">{t("Print the ticket")}</div>
      <div className="popup-main-content">
        <p className="text-center">{t("You can print your booked bet")}</p>
        <div className="booking-id-container">
          <span>{t("Booking ID")}</span>
          <span>{bookingData.bookId}</span>
        </div>
      </div>
      <div className="popup-actions">
        <button className="popup-cancel-button" onClick={closePopup}>
          {t("Close")}
        </button>
        <button className="popup-confirm-button" onClick={handlePrintTicket}>
          {t("Print")}
        </button>
      </div>
    </div>
  );
};
